import { render, staticRenderFns } from "./AudioRecordingView.vue?vue&type=template&id=4e881921&scoped=true&"
import script from "./AudioRecordingView.vue?vue&type=script&lang=ts&"
export * from "./AudioRecordingView.vue?vue&type=script&lang=ts&"
import style0 from "./AudioRecordingView.vue?vue&type=style&index=0&id=4e881921&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e881921",
  null
  
)

export default component.exports